import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard  {
  constructor(
    private _location: Location,
    private userService: UserService
  ) { }
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    let admin;
    await this.userService.getUser(false)
      .then(data => admin = data.userType)
    if (admin === undefined) {
      this._location.back()
      return false;
    }
    else {
      return true
    }
  }
}
